export const isSuperUserSoldTab = (isSuperUser: boolean, tab: string): boolean =>
  isSuperUser && tab === 'Sold';

export const isSuperUserDelistedTab = (isSuperUser: boolean, tab: string): boolean =>
  isSuperUser && tab === 'Delisted';

export const isSuperUserUnsoldTab = (isSuperUser: boolean, tab: string): boolean =>
  isSuperUser && tab === 'Unsold';

export const isSuperUserListedStatusReadOnly = (isSuperUser: boolean, tab: string): boolean =>
  isSuperUser && tab === 'Listed';

export const hidesSuperUserTicketDetails = (isSuperUser: boolean, tab: string): boolean =>
  isSuperUserSoldTab(isSuperUser, tab) ||
  isSuperUserDelistedTab(isSuperUser, tab) ||
  isSuperUserUnsoldTab(isSuperUser, tab);

export const hidesSuperUserEventCardDetails = (isSuperUser: boolean, tab: string): boolean =>
  hidesSuperUserTicketDetails(isSuperUser, tab) ||
  (isSuperUser && tab === 'Listed');
